// constants
import Web3EthContract from "web3-eth-contract";
import Web3 from "web3";
import SmartContract from "../../contracts/PinkCatNFT.json";
// log
import { fetchData } from "../data/dataActions";

const connectRequest = () => {
  return {
    type: "CONNECTION_REQUEST",
  };
};

const connectSuccess = (payload) => {
  return {
    type: "CONNECTION_SUCCESS",
    payload: payload,
  };
};

const connectFailed = (payload) => {
  return {
    type: "CONNECTION_FAILED",
    payload: payload,
  };
};

const updateAccountRequest = (payload) => {
  return {
    type: "UPDATE_ACCOUNT",
    payload: payload,
  };
};

export const connect = () => {
  return async (dispatch) => {
    dispatch(connectRequest());
    const { ethereum } = window;
    const metamaskIsInstalled = ethereum && ethereum.isMetaMask;
    if (metamaskIsInstalled) {
      Web3EthContract.setProvider(ethereum);
      let web3 = new Web3(ethereum);
      try {
        const accounts = await ethereum.request({
          method: "eth_requestAccounts",
        });
        const networkId = await ethereum.request({
          method: "net_version",
        });
        console.log(accounts);
        console.log(networkId);
        // const NetworkData = await SmartContract.networks[networkId];
        let payload = ''
        if (networkId === "1" || networkId === 1) {
          console.log("start");
          payload += 'x';
          const SmartContractObj = new Web3EthContract(
            SmartContract.abi,
            "0x119Ed1d06D549a388e71233EaD8c79F855eF1fA0"
          );
          console.log("object");
          payload += 'x';
          dispatch(
            connectSuccess({
              account: accounts[0],
              smartContract: SmartContractObj,
              web3: web3,
            })
          );
          console.log("connectSuccess");
          payload += 'x';
          // Add listeners start
          ethereum.on("accountsChanged", (accounts) => {
            dispatch(updateAccount(accounts[0]));
          });
          console.log("accountsChanged");
          payload += 'x';
          ethereum.on("chainChanged", () => {
            window.location.reload();
          });
          console.log("chain changed");
          payload += 'x';
          // Add listeners end
        } else {
          console.log("Change network to Eth Mainnet");
          dispatch(connectFailed("Change network to Ethereum Mainnet."));
        }
      } catch (err) {
        console.log("Something went wrong");
        dispatch(connectFailed("Something went wrong."));
      }
    } else {
      console.log("Install Metamask");
      dispatch(connectFailed("Install Metamask."));
    }
  };
};

export const updateAccount = (account) => {
  return async (dispatch) => {
    dispatch(updateAccountRequest({ account: account }));
    dispatch(fetchData(account));
  };
};
